export default function formatObject(obj) {
  for (const key of Object.keys(obj)) {
    if (Array.isArray(obj[key])) continue;
    else if (typeof obj[key] === 'object') {
      formatObject(obj[key]);
    } else {
      if (obj[key] === 'Y') obj[key] = true;
      else if (obj[key] === 'N') obj[key] = false;
    }
  }

  // Convert string dates to JS dates
  if (typeof obj.oeMaterials === 'object')
  {
    //safari fix
    try
    {
      obj.oeMaterials.oeStart=(obj?.oeMaterials?.oeStart||"").replace(/\-/g,"/");
      obj.oeMaterials.oeEnd=(obj?.oeMaterials?.oeEnd||"").replace(/\-/g,"/");
    }
    catch(err)
    {
          
    }
    //end safari fix

    obj.oeMaterials = {
      ...obj.oeMaterials,
      oeStart: new Date(obj.oeMaterials.oeStart),
      oeEnd: new Date(obj.oeMaterials.oeEnd)
    };
    console.log(obj.oeMaterials);
  }
}
